export const SERVICE_REQUEST_ID_SUCCESS = "SERVICE_REQUEST_ID_SUCCESS"
export const SERVICE_REQUEST_EXIT_PAGE = "SERVICE_REQUEST_EXIT_PAGE"
